import { render } from "./PulmonarySection.vue?vue&type=template&id=b9f1fe9a"
import script from "./PulmonarySection.vue?vue&type=script&lang=js"
export * from "./PulmonarySection.vue?vue&type=script&lang=js"

import "./PulmonarySection.vue?vue&type=style&index=0&id=b9f1fe9a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__